import { render } from "./DatasetCleanerDesc.vue?vue&type=template&id=827b9590"
import script from "./DatasetCleanerDesc.vue?vue&type=script&lang=js"
export * from "./DatasetCleanerDesc.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__